<script setup>
import { ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { Delete, View, Upload } from '@element-plus/icons-vue'


const selectedChecklist = ref('CONSORT')
const fileList = ref([
  {
    fileName: '2023-Selection of the optimal dose of sertra...alysis of randomized controlled trials.pdf',
    checklist: 'PRISMA',
    uploadTime: '2024-04-14 22:56:17',
    finishedTime: '2024-04-14 22:56:17',
    status: 'Completed'
  },
  // ... 可以添加更多初始数据
])

const currentFile = ref({
  name: '307-中华医学杂志-无创性影像学技术评估静脉治疗相关心血管事件的临床应用指南2023版.pdf',
  status: 'ready'
})


// 文件上传相关方法
const handleUpload = (file) => {
  currentFile.value = file
  return false // 阻止自动上传
}

const handleRun = () => {
  if (!currentFile.value) {
    ElMessage.warning('请先上传文件')
    return
  }
  ElMessage.success('开始处理文件')
}

const handleDetail = (row) => {
  console.log('查看详情:', row)
}

const formatDate = (date) => {
  return new Date(date).toLocaleString()
}
</script>

<template>
  <div class="advanced-writer">
    <!-- 头部区域 -->
    <header class="header" v-motion="headerMotion">
      <div class="header-content">
        <div class="logo-section">
          <img src="@/assets/logo.svg" alt="Advanced Logo" class="logo"/>
          <span class="brand">ADVANCED</span>
        </div>
        <div class="user-section">
          <el-badge :value="2" class="notification">
            <el-icon><Bell /></el-icon>
          </el-badge>
          <div class="admin">
            <el-avatar size="small" />
            <span>admin</span>
          </div>
        </div>
      </div>
    </header>

    <!-- 主要内容区域 -->
    <main class="main-content">
      <div class="title-section" v-motion="headerMotion">
        <h1>ADVANCED Writer</h1>
        <p class="subtitle">An AI agent designed to assist in the standardization of manuscript reporting and facilitate rapid evaluation</p>
        <p class="subtitle-cn">妙笔 -- 帮助作者撰写更加完整、规范和清晰的文章，提示编辑和审稿人快速确定文章的报告质量，指出报告存在的问题</p>
      </div>

      <!-- 上传区域 -->
      <div class="upload-section" v-motion="uploadMotion">
        <el-upload
          class="upload-area"
          drag
          action="#"
          :auto-upload="false"
          :on-change="handleUpload"
        >
          <div v-if="!currentFile.name">
            <el-icon class="upload-icon"><Upload /></el-icon>
            <div class="upload-text">
              Drag and drop the file here or <span class="click-upload">click Upload</span>
            </div>
            <div class="upload-tip">support WORD and PDF</div>
          </div>
          <div v-else class="file-info">
            <el-icon><Document /></el-icon>
            <span class="file-name">{{ currentFile.name }}</span>
          </div>
        </el-upload>

        <!-- 控制栏 -->
        <div class="control-bar">
          <div class="checklist-select">
            <span>checklist:</span>
            <el-select v-model="selectedChecklist">
              <el-option value="CONSORT" label="CONSORT" />
              <el-option value="PRISMA" label="PRISMA" />
            </el-select>
          </div>
          <el-button type="primary" @click="handleRun">Run</el-button>
        </div>
      </div>

      <!-- 文件列表 -->
      <div class="file-list" v-motion="tableMotion">
        <div class="list-header">
          <span>Recent Files</span>
          <el-link type="primary" class="more-link">more</el-link>
        </div>
        <el-table :data="fileList" style="width: 100%">
          <el-table-column prop="fileName" label="File Name" min-width="300" />
          <el-table-column prop="checklist" label="Checklist" width="120" />
          <el-table-column prop="uploadTime" label="Upload time" width="180">
            <template #default="scope">
              {{ formatDate(scope.row.uploadTime) }}
            </template>
          </el-table-column>
          <el-table-column prop="finishedTime" label="Finished time" width="180">
            <template #default="scope">
              {{ formatDate(scope.row.finishedTime) }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="Status" width="120">
            <template #default="scope">
              <el-tag :type="scope.row.status === 'Completed' ? 'success' : 'warning'">
                {{ scope.row.status }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Operation" width="100" fixed="right">
            <template #default="scope">
              <el-button 
                link 
                type="primary" 
                @click="handleDetail(scope.row)"
              >
                Detail
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </main>
  </div>
</template>

<style scoped>
.advanced-writer {
  min-height: 100vh;
  background: linear-gradient(to bottom, #ffffff, #e6f7ff);
  padding: 20px;
}

.header {
  margin-bottom: 40px;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo {
  height: 32px;
}

.brand {
  font-size: 20px;
  font-weight: bold;
}

.user-section {
  display: flex;
  align-items: center;
  gap: 24px;
}

.notification {
  cursor: pointer;
}

.admin {
  display: flex;
  align-items: center;
  gap: 8px;
}

.main-content {
  max-width: 1200px;
  margin: 0 auto;
}

.title-section {
  text-align: center;
  margin-bottom: 40px;
}

.title-section h1 {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 16px;
}

.subtitle, .subtitle-cn {
  color: #666;
  margin-bottom: 8px;
}

.upload-section {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;
}

.upload-area {
  width: 100%;
  margin-bottom: 24px;
}

.upload-icon {
  font-size: 48px;
  color: var(--el-color-primary);
}

.upload-text {
  margin: 16px 0;
}

.click-upload {
  color: var(--el-color-primary);
  cursor: pointer;
}

.upload-tip {
  color: #999;
  font-size: 14px;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
}

.file-name {
  color: #666;
  word-break: break-all;
}

.control-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  border-top: 1px solid #eee;
}

.checklist-select {
  display: flex;
  align-items: center;
  gap: 8px;
}

.file-list {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

:deep(.el-upload-dragger) {
  width: 100%;
  height: 200px;
}

:deep(.el-button--primary) {
  background-color: #4db6ac;
}

:deep(.el-select) {
  width: 160px;
}

:deep(.el-table) {
  --el-table-border-color: #ebeef5;
  --el-table-header-bg-color: #f5f7fa;
}
</style>
